import * as React from "react";
import {AppBar, Box, Tab, Tabs} from "@mui/material";
import SectorDist from "./charts/SectorDist";
import ProvincialDist from "./charts/ProvincialDist";
import {useState} from "react";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const StatsChart = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
    };

    return (
        <React.Fragment>
            <AppBar position="static" style={{background: '#ffffff'}}>
                <Tabs
                    value={tabIndex}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    variant="fullWidth"
                    sx={{
                        width: "100%", height: "100%",
                    }}
                >

                    <Tab label="Region Dist" {...a11yProps(0)} sx={{
                        color: "#443838",
                        fontFamily: "Barlow, Helvetica", fontSize: "20px",
                        fontWeight: 600
                    }} />
                    <Tab label="4RF-SRO Dist" {...a11yProps(1)}
                         sx={{
                             color: "#443838",
                             fontFamily: "Barlow, Helvetica", fontSize: "20px",
                             fontWeight: 600
                         }}
                    />
                    {/*<Tab  label="Donor Wise" {...a11yProps(2)} />*/}
                </Tabs>
            </AppBar>

            <TabPanel value={0} index={tabIndex}>
                <ProvincialDist/>
            </TabPanel>
            <TabPanel value={1} index={tabIndex}>
                <SectorDist/>
            </TabPanel>
            {/*<TabPanel value={2} index={tabIndex}>*/}
            {/*    <DonorDist />*/}
            {/*</TabPanel>*/}
        </React.Fragment>
    );
}

export default StatsChart

